import initialState from './initial.state';
import * as ActionTypes from '../actions/types.action';

export default function restaurantCodeReducer(state = initialState.restaurantCode, action) {
  switch (action.type) {
    case ActionTypes.SET_RESTAURANT_CODE_SUCCESS:
      return action.restaurantCode;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/restaurantCode.reducer.js